module.exports = __webpack_public_path__ + "img/consensuslab.b37e2c53.svg";